import { ClubLocalModule } from '@modules/application/application';

export const InscriptionLocalModule: ClubLocalModule = {
    code: '68eaac650f98dc404f79ba7f85ab7754',
    icon: 'global',
    localEnabled: true,
    name: 'Academias / Preinscripción',
    url: '/inscription/history',
    includeInNavigation: true,
};
